import { Button } from '@mui/material'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { TeamAddForm } from './TeamAddForm'

interface TeamAddControlProps {
  isOrg?: boolean
  onRefetch: () => void
}

export function TeamAddControl({ isOrg = false, onRefetch }: TeamAddControlProps) {
  const [isOpen, handleOpen, handleClose] = useShowControl()

  return (
    <>
      <Button variant="contained" sx={{ minWidth: 120 }} onClick={handleOpen}>
        Add Team
      </Button>

      <UIModal title="Add Team" isOpen={isOpen} onClose={handleClose}>
        <TeamAddForm isOrg={isOrg} onClose={handleClose} onRefetch={onRefetch} />
      </UIModal>
    </>
  )
}
